import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"

const Header = ({ pageTitle }) => (
  <header
    style={{
      marginBottom: `1.45rem`,
      width: `100%`
    }}
  >
    <div
      style={{
        margin: `0 auto`,
        padding: `1.45rem 1.0875rem`,
        textAlign: `center`
      }}
    >
      <h1 style={{ margin: 0 }}>
        <Link
          to="/"
          style={{
            color: `white`,
            textDecoration: `none`,
          }}
        >
          {pageTitle}
        </Link>
      </h1>
    </div>
  </header>
)

Header.propTypes = {
  pageTitle: PropTypes.string,
}

Header.defaultProps = {
  pageTitle: ``,
}

export default Header
